import React, { useMemo } from 'react';
import { clinicalAssessmentCatalog, buildCatalogStatusMap } from '../../data/clinicalAssessmentCatalog';

/**
 * Core catalog coverage vs recorded / quick-saved assessments (admission + ongoing parity helper).
 */
export default function MandatoryAssessmentCoverageGrid({ recordedAssessments = [] }) {
  const statusBySlug = useMemo(() => buildCatalogStatusMap(recordedAssessments), [recordedAssessments]);

  const labelFor = (slug) => {
    const s = statusBySlug[slug]?.status;
    if (s === 'completed') return { text: 'Completed / on file', cls: 'bg-emerald-100 text-emerald-900 border-emerald-200' };
    if (s === 'on-file') return { text: 'In progress', cls: 'bg-amber-100 text-amber-900 border-amber-200' };
    return { text: 'Not recorded (demo)', cls: 'bg-slate-100 text-slate-600 border-slate-200' };
  };

  return (
    <div className="rounded-xl border-2 border-indigo-100 bg-white shadow-sm overflow-hidden">
      <div className="border-b border-indigo-100 bg-indigo-50/80 px-4 py-3">
        <h3 className="text-sm font-bold text-indigo-900 uppercase tracking-wide">Mandatory &amp; core assessment coverage</h3>
        <p className="text-xs text-indigo-800/90 mt-1">
          35 core tools from the catalog — status derives from recorded assessments + saved quick forms (local demo).
        </p>
      </div>
      <div className="max-h-[28rem] overflow-y-auto">
        <table className="w-full text-left text-sm">
          <thead className="sticky top-0 bg-white border-b border-gray-200 text-xs uppercase text-gray-500">
            <tr>
              <th className="px-3 py-2 font-semibold">#</th>
              <th className="px-3 py-2 font-semibold">Assessment</th>
              <th className="px-3 py-2 font-semibold">Domain</th>
              <th className="px-3 py-2 font-semibold">Regulatory timing (summary)</th>
              <th className="px-3 py-2 font-semibold">Status</th>
            </tr>
          </thead>
          <tbody>
            {clinicalAssessmentCatalog.map((row) => {
              const st = labelFor(row.slug);
              return (
                <tr key={row.slug} className="border-b border-gray-100 hover:bg-gray-50/80">
                  <td className="px-3 py-2 text-gray-500 font-mono text-xs">{row.id}</td>
                  <td className="px-3 py-2 font-medium text-gray-900">{row.name}</td>
                  <td className="px-3 py-2 text-gray-600">{row.domain}</td>
                  <td className="px-3 py-2 text-gray-600 text-xs leading-snug max-w-[14rem]">{row.due}</td>
                  <td className="px-3 py-2">
                    <span className={`inline-flex text-[10px] font-bold px-2 py-0.5 rounded border ${st.cls}`}>{st.text}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
